import { getImageFields } from '@utils';
import { IMG_TYPES } from '@atoms/Img';

export default ({ name, url, logo }) => ({
  name,
  url,
  logo: getImageFields(logo, IMG_TYPES.fixed),
});
